<template>
  <div v-if="stack" transition="modal" class="backdrop" v-on:click="dismissModal">
    <form class="edit-card-form create edit-stack" v-on:submit.prevent="update" v-on:click.stop="">
      <textarea class="form-stack-title" name="title" v-model="stack.title" placeholder="Title"></textarea>
      <textarea name="description" v-model="stack.description" placeholder="why learn this?" rows="2" class="stack-why"></textarea>
      <button type="submit">Done</button>
    </form>
  </div>
</template>

<script>
  import stackFunctions from '../../data/stackFunctions'
  import EventBus from '../EventBus'
  export default {
    data() {
      return {
        stack: null
      }
    },
    created: function () {
      EventBus.$on('stack.selected', this.selectStack)
    },
    beforeDestroy: function () {
      EventBus.$off('stack.selected', this.selectStack)
    },
    methods: {
      selectStack: function(stack){
        this.stack = stack
        
      },
      remove () {
        stackFunctions.remove(this.stack, (err) => {
          if (err) throw err // TODO: inform the user
          this.dismissModal()
        })
      },
      update () {
        stackFunctions.update(this.stack, (err) => {
          if (err) throw err // TODO: inform the user
          this.dismissModal()
        })
      },
      dismissModal () {
        this.stack = null
      }
    }
  }
</script>

<style>

  
</style>


// WEBPACK FOOTER //
// UpdateStackModal.vue?3fe1cfef